// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlock_root__YHSBC","title":"PricingBlock_title__HGxbK"};